import { render, staticRenderFns } from "./Gaarkeuken2.vue?vue&type=template&id=5d393b64&"
import script from "./Gaarkeuken2.vue?vue&type=script&lang=ts&"
export * from "./Gaarkeuken2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports